export const APP_BASENAME = process.env.NODE_ENV === 'production' ? '/react-start-template' : '';
